import { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import Axios from 'axios';
import { nearestTown } from '../../constants/api';
import { PATH } from '../../envs/core';

export const nearestTownRest = (townId, latitude, longitude) => {
  const id = `id=${townId}`;
  const lat = `&lat=${latitude}`;
  const lon = `&lon=${longitude}`;

  const filter = `${id}${lat}${lon}&size=20`;

  return Axios.get(`${PATH}${nearestTown}${filter}`).then(response => {
    return response;
  });
};

export const NearestTownProvider = ({
  townId,
  longitude,
  latitude,
  children
}) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    nearestTownRest.then(response => {
      setData(response.data.content);
    });
  }, [townId, latitude, longitude]);

  return children(data);
};

NearestTownProvider.propTypes = {
  townId: PropTypes.string.isRequired,
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  children: PropTypes.func.isRequired
};

NearestTownProvider.defaultProps = {
  latitude: 0,
  longitude: 0
};
